import { ENTITY_TYPES } from "@/other/constants/OtherKeys";
import { STORE_KEYS } from "@/other/constants/StoreKeys";
import { TAGS_KEYS } from "@/other/constants/TagsKeys";

type KanbanFieldConfig = {
  grouperField: string;
  setterField: string;
  grouperStoreId?: string;
  grouperStoreFilterFn?: (record: any) => boolean;
  isNotNullable?: boolean;
  customOrderConfig?: {
    field: string;
    storeName: string;
  };
};

type EntityTypeValue = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

const TAG_VALUE_CONFIG: Record<EntityTypeValue, KanbanFieldConfig[]> = {
  [ENTITY_TYPES.TASK]: [
    {
      grouperField: "statusValue",
      setterField: "statusId",
      grouperStoreId: STORE_KEYS.taskTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.status,
      customOrderConfig: {
        field: "statusId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "categoryValue",
      setterField: "categoryId",
      grouperStoreId: STORE_KEYS.taskTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.category,
      customOrderConfig: {
        field: "categoryId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "phaseValue",
      setterField: "phaseId",
      grouperStoreId: STORE_KEYS.taskTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.phase,
      customOrderConfig: {
        field: "phaseId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "teamValue",
      setterField: "teamId",
      grouperStoreId: STORE_KEYS.boardTeamsStore,
      grouperStoreFilterFn: () => true,
      customOrderConfig: {
        field: "teamId",
        storeName: "teamStore"
      }
    },
    {
      grouperField: "tagsValue",
      setterField: "tagsId",
      grouperStoreId: STORE_KEYS.taskTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.tag
    }
  ],
  [ENTITY_TYPES.RESOURCE]: [
    {
      grouperField: "statusValue",
      setterField: "statusId",
      grouperStoreId: STORE_KEYS.resourceTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.status,
      customOrderConfig: {
        field: "statusId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "categoryValue",
      setterField: "categoryId",
      grouperStoreId: STORE_KEYS.resourceTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.category,
      customOrderConfig: {
        field: "categoryId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "teamValue",
      setterField: "teamId",
      grouperStoreId: STORE_KEYS.boardTeamsStore,
      grouperStoreFilterFn: () => true,
      customOrderConfig: {
        field: "teamId",
        storeName: "teamStore"
      }
    },
    {
      grouperField: "typeValue",
      setterField: "typeId",
      grouperStoreId: STORE_KEYS.resourceTypeStore,
      grouperStoreFilterFn: () => true,
      customOrderConfig: {
        field: "typeId",
        storeName: "resourceTypeStore"
      }
    },
    {
      grouperField: "tagsValue",
      setterField: "tagsId",
      grouperStoreId: STORE_KEYS.resourceTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.tag
    }
  ],
  [ENTITY_TYPES.CLIENT]: [
    {
      grouperField: "statusValue",
      setterField: "statusId",
      grouperStoreId: STORE_KEYS.clientTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.status,
      customOrderConfig: {
        field: "statusId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "categoryValue",
      setterField: "categoryId",
      grouperStoreId: STORE_KEYS.clientTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.category,
      customOrderConfig: {
        field: "categoryId",
        storeName: "tagStore"
      }
    },
    {
      grouperField: "teamValue",
      setterField: "teamId",
      grouperStoreId: STORE_KEYS.boardTeamsStore,
      grouperStoreFilterFn: () => true,
      customOrderConfig: {
        field: "teamId",
        storeName: "teamStore"
      }
    },
    {
      grouperField: "tagsValue",
      setterField: "tagsId",
      grouperStoreId: STORE_KEYS.clientTagValuesStore,
      grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.tag
    }
  ],
  // [ENTITY_TYPES.CONTACT]: [
  //   {
  //     grouperField: "statusValue",
  //     setterField: "statusId",
  //     grouperStoreId: STORE_KEYS.contactTagValuesStore,
  //     grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.status
  //   },
  //   {
  //     grouperField: "categoryValue",
  //     setterField: "categoryId",
  //     grouperStoreId: STORE_KEYS.contactTagValuesStore,
  //     grouperStoreFilterFn: (record: any) => record.tagSet === TAGS_KEYS.category
  //   }
  // ]
};

export const KANBAN_FIELD_CONFIG: Record<EntityTypeValue, KanbanFieldConfig[]> = {
  [ENTITY_TYPES.TASK]: TAG_VALUE_CONFIG[ENTITY_TYPES.TASK],
  [ENTITY_TYPES.RESOURCE]: TAG_VALUE_CONFIG[ENTITY_TYPES.RESOURCE],
  [ENTITY_TYPES.CLIENT]: TAG_VALUE_CONFIG[ENTITY_TYPES.CLIENT]
};
